
import React from 'react';
import { Link } from 'react-router-dom';
import { useFeaturedBlogPost } from '@/hooks/useBlogPosts';
import { Calendar, User } from 'lucide-react';
import { Button } from '@/components/ui/button';

const FeaturedBlog: React.FC = () => {
  const { data: featuredPost, isLoading, error } = useFeaturedBlogPost();

  if (isLoading) {
    return (
      <div className="mb-12 bg-gray-50 rounded-xl overflow-hidden shadow-sm border border-gray-100">
        <div className="p-6 md:p-8">
          <div className="animate-pulse">
            <div className="h-6 bg-gray-200 rounded w-24 mb-4"></div>
            <div className="h-8 bg-gray-200 rounded w-3/4 mb-4"></div>
            <div className="h-4 bg-gray-200 rounded w-full mb-2"></div>
            <div className="h-4 bg-gray-200 rounded w-2/3 mb-6"></div>
            <div className="h-4 bg-gray-200 rounded w-32 mb-6"></div>
            <div className="h-10 bg-gray-200 rounded w-48"></div>
          </div>
        </div>
      </div>
    );
  }

  if (error || !featuredPost) {
    return (
      <div className="mb-12 bg-gray-50 rounded-xl overflow-hidden shadow-sm border border-gray-100">
        <div className="p-6 md:p-8 text-center">
          <p className="text-gray-500">No hay artículos destacados disponibles.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="mb-12 bg-gray-50 rounded-xl overflow-hidden shadow-sm border border-gray-100">
      <div className="p-6 md:p-8">
        <div className="mb-4">
          <span className="bg-primary/10 text-primary text-xs font-medium px-3 py-1 rounded-full">
            Destacado
          </span>
        </div>
        
        <h2 className="text-2xl md:text-3xl font-bold text-navy mb-4 leading-tight">
          <Link to={`/blog/${featuredPost.slug}`} className="hover:text-primary transition-colors">
            {featuredPost.title}
          </Link>
        </h2>
        
        <p className="text-coolGray mb-6 line-clamp-3 text-base leading-relaxed">
          {featuredPost.excerpt}
        </p>
        
        <div className="flex flex-wrap items-center gap-4 text-sm text-coolGray mb-6">
          <div className="flex items-center gap-2">
            <Calendar className="h-4 w-4" />
            <span>{new Date(featuredPost.date).toLocaleDateString('es-ES', { 
              year: 'numeric', 
              month: 'long', 
              day: 'numeric' 
            })}</span>
          </div>
          <div className="flex items-center gap-2">
            <User className="h-4 w-4" />
            <span>{featuredPost.author}</span>
          </div>
        </div>
        
        <Link to={`/blog/${featuredPost.slug}`}>
          <Button className="bg-primary hover:bg-primary/90 text-white font-medium">
            Leer artículo completo
          </Button>
        </Link>
      </div>
    </div>
  );
};

export default FeaturedBlog;
